/**
 * IQMax Vertical Types — Education marketplace types
 */

export enum CourseStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  ARCHIVED = 'ARCHIVED',
}

export enum ScheduleStatus {
  SCHEDULED = 'SCHEDULED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export enum EnrollmentStatus {
  ENROLLED = 'ENROLLED',
  ATTENDED = 'ATTENDED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  NO_SHOW = 'NO_SHOW',
}

export interface Course {
  id: string;
  title: string;
  description: string;
  teacherId: string;
  subject: string;
  gradeLevel: string[];
  duration: number;
  maxStudents: number;
  price: number;
  status: CourseStatus;
  requirements: string[];
  learningObjectives: string[];
  materials: CourseMaterial[];
  schedules: CourseSchedule[];
  createdAt: Date;
  updatedAt: Date;
}

export interface CourseMaterial {
  id: string;
  title: string;
  type: string;
  url: string;
  size?: number;
}

export interface CourseSchedule {
  id: string;
  courseId: string;
  startTime: Date;
  endTime: Date;
  maxStudents: number;
  enrolledStudents: string[];
  status: ScheduleStatus;
}

export interface Enrollment {
  id: string;
  studentId: string;
  courseId: string;
  scheduleId: string;
  status: EnrollmentStatus;
  paymentStatus: string;
  enrolledAt: Date;
  completedAt?: Date;
}

export interface Review {
  id: string;
  studentId: string;
  teacherId: string;
  courseId: string;
  rating: number;
  comment: string;
  createdAt: Date;
}

export interface Payment {
  id: string;
  studentId: string;
  teacherId: string;
  courseId: string;
  amount: number;
  currency: string;
  status: string;
  paymentMethod: string;
  transactionId: string;
  createdAt: Date;
  processedAt?: Date;
}

export interface Message {
  id: string;
  conversationId: string;
  senderId: string;
  receiverId: string;
  content: string;
  type: string;
  attachments: MessageAttachment[];
  sentAt: Date;
  readAt?: Date;
}

export interface MessageAttachment {
  id: string;
  filename: string;
  url: string;
  size: number;
  mimeType: string;
}

export interface Conversation {
  id: string;
  participants: string[];
  lastMessage?: Message;
  createdAt: Date;
  updatedAt: Date;
}
